<template>
  <div>
    <template v-if="imgDialog">
      <el-dialog
        append-to-body
        :visible="imgDialog"
        class="imgDialog"
        width="30%"
        :before-close="handlConfigClose"
        top="0"
      >
        <div class="config-box">
          <template v-for="(item,index) in imgsrcDesc">
            <div
              :key="index"
              class="config-img"
            >
              <img
                v-if="item.Type === 'img'"
                :src="item.Value"
              >
              <div
                v-if="item.Type==='txt'"
                class="config-txt"
              >
                {{ item.Value }}

                <div style="text-align: right;">
                  <el-button
                    class="config-button"
                    @click="handlConfigNext()"
                  >
                    {{ $t('deviceMsg.know') }}
                  </el-button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { GetUIGuideDataList } from '@/axios/IDevice.js'
import { CONFIGTYPE , APPTYPE} from '@/utils/enums'

export default {
  props: {
    device:{
      type:Object,
      required:true
    },
  },
  data () {
    return {
      imgsrcDesc:[],//低功耗设备提示
      imgDialog:false, //低功耗设备提示对话框
      appTypeWeb:APPTYPE.web,//1:欧普智慧灯光;2:欧普智能家庭;3:欧普智家;4:商照
      type:CONFIGTYPE.composite, //1:SSid 更换引导; 2:被动识别; 4:综合引导
      identifNone:this.$t('devicecard.identifNone')
    }
  },
  methods:{
     /**
     * 获取引导页资源
     * @param {1 | 2 | 4 } type 1:SSid 更换引导; 2:被动识别; 4:综合引导
     * @param {1 | 2 | 3 | 4} appType app类型，1:欧普智慧灯光;2:欧普智能家庭;3:欧普智家;4:商照
     * @returns {Promise} request promise
     */
     doGetUIGuideDataList(){
      const para = {
        appType:this.appTypeWeb,
        classSku:this.device.ClassSku,
        type:this.type
      }
      GetUIGuideDataList(para,this.functionGetUIGuideDataList)
    },
    functionGetUIGuideDataList(rs){

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result.length > 0) {
          this.imgsrcDesc = rs.Result || []
          this.imgDialog = true
        }else{
          this.imgsrcDesc = [{
            Type: 'img', Value: require('@static/device/identify/none.png')
          }, {
            Type: 'txt',
            Value: this.identifNone
          }]
          this.imgDialog = true
        }
      }
    },
    handlConfigNext(){
      this.imgDialog = false
      this.$emit('handleSaveConfig')
    },
    handlConfigClose (done) {
      done()
      this.imgDialog = false
      this.imgsrcDesc = []
    },
  }
}
</script>
<style lang="scss" scoped>
.config-box{
  display: flex;
  align-items: center;
  .config-img{
    img{
      width: 90px;
      height: 90px;
    }
    
  }
  .config-txt{
    margin-left: 20px;
  }
  .config-button{
    margin-top: 40px;
    background: #2145A4;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
  }
}

</style>